<template>
  <div class="">
    <div class="sm:flex sm:items-center mb-4">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold leading-6 text-gray-900">Manage Float</h1>
      </div>
      <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none flex">
        <router-link to="/buffer_management" class="
            border
            px-6
            py-2
            rounded-lg
            text-sm
            mr-2
            flex
            justify-center
            items-center
            hover:bg-gray-100
          ">
          Buffer Management
        </router-link>
        <router-link to="/replenishment" class="
            border
            px-6
            py-2
            rounded-lg
            text-sm
            flex
            justify-center
            items-center
            hover:bg-gray-100
          ">
          Float Replenishment
        </router-link>
      </div>
    </div>

    <!-- Filters Section -->
    <div class="bg-white border border-gray-200 rounded-lg mb-4 shadow-sm">
      <div 
        @click="showFilters = !showFilters"
        class="flex items-center justify-between p-4 cursor-pointer hover:bg-gray-50 transition-colors"
      >
        <h3 class="text-sm font-medium text-gray-700 flex items-center">
          <i class="bx bx-filter-alt mr-1"></i> Filters
          <span v-if="activeFilterCount > 0" class="ml-2 px-2 py-0.5 bg-indigo-100 text-indigo-700 text-xs rounded-full">
            {{ activeFilterCount }} active
          </span>
        </h3>
        <div class="flex items-center space-x-2">
          <button 
            v-if="showFilters"
            @click.stop="clearFilters" 
            class="text-xs text-gray-500 hover:text-gray-700 flex items-center"
          >
            <i class="bx bx-x mr-1"></i> Clear All
          </button>
          <i :class="showFilters ? 'bx bx-chevron-up' : 'bx bx-chevron-down'" class="text-gray-500 text-lg"></i>
        </div>
      </div>
      <div v-show="showFilters" class="px-4 pb-4">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        <!-- Transaction Date Filter -->
        <div>
          <label class="block text-xs font-medium text-gray-600 mb-1">Transaction Date From</label>
          <input 
            type="date" 
            v-model="filters.dateFrom"
            class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>
        <div>
          <label class="block text-xs font-medium text-gray-600 mb-1">Transaction Date To</label>
          <input 
            type="date" 
            v-model="filters.dateTo"
            class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>
        <!-- Created At Filter -->
        <div>
          <label class="block text-xs font-medium text-gray-600 mb-1">Created From</label>
          <input 
            type="date" 
            v-model="filters.createdFrom"
            class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>
        <div>
          <label class="block text-xs font-medium text-gray-600 mb-1">Created To</label>
          <input 
            type="date" 
            v-model="filters.createdTo"
            class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>
        <!-- Bank Filter -->
        <div>
          <label class="block text-xs font-medium text-gray-600 mb-1">Bank</label>
          <input 
            type="text" 
            v-model="filters.bank"
            placeholder="Search bank..."
            class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
        <!-- Replenished By Filter -->
        <div>
          <label class="block text-xs font-medium text-gray-600 mb-1">Replenished By</label>
          <input 
            type="text" 
            v-model="filters.createdBy"
            placeholder="Search user..."
            class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>
        <!-- Apply Button -->
        <div class="flex items-end">
          <button 
            @click="applyFilters"
            :disabled="loading"
            class="w-full px-4 py-2 bg-indigo-600 text-white text-sm font-medium rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:opacity-50"
          >
            <i class="bx bx-search mr-1"></i> Apply Filters
          </button>
        </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col">
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div class="
              shadow
              overflow-hidden
              border-b border-gray-200
              sm:rounded-lg
            ">
            <!-- Loading Overlay -->
            <div v-if="loading" class="flex items-center justify-center py-12">
              <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
              <span class="ml-2 text-gray-600">Loading...</span>
            </div>
            <table v-else class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>

                  <th scope="col" class="
                      px-6
                      py-3
                      text-left text-sm
                      text-gray-900
                      tracking-wider
                    ">
                    Bank
                  </th>
                  <th scope="col"
                    class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">
                    Date
                  </th>
                  <th scope="col" class="
                      px-6
                      py-3
                      text-left text-sm
                      text-gray-900
                      
                      tracking-wider
                    ">
                    Total
                  </th>

                  <th scope="col"
                    class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">
                    Replenished By
                  </th>

                  <th scope="col"
                    class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">
                    Created At
                  </th>

                  <th scope="col" class="relative px-6 py-3">
                    <span class="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>
              <tbody v-if="floats" class="bg-white divide-y divide-gray-200">
                <tr v-for="(float, i) in floats.data" :key="i">

                  <td class="px-5 py-4 whitespace-nowrap">
                    <div class="text-sm font-medium text-gray-900">
                      {{ float.bank_name }}
                    </div>
                    <div class="text-xs text-gray-500">
                      SN:{{ float.slip_number }}
                    </div>
                    <div class="md:hidden text-xs text-gray-500">
                      {{ float.created_at | moment("ddd, MMM Do YYYY, h:mm:ss a") }}
                    </div>
                  </td>
                  <td class="hidden sm:table-cell px-6 py-4 whitespace-nowrap">
                    {{ float.date }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap ">
                    GMD {{ formatPrice(total(float.allocations)) }}
                  </td>
                  <td class="px-6 text-sm py-4 whitespace-nowrap hidden sm:table-cell">
                    {{ float.created_by }}
                  </td>
                  <td class="px-6 text-sm py-4 whitespace-nowrap hidden sm:table-cell">
                    {{
                float.created_at | moment("ddd, MMM Do YYYY, h:mm:ss a")
              }}
                  </td>

                  <td class="
                      px-6
                      py-4
                      whitespace-nowrap
                      text-right text-sm
                      font-medium
                      
                    ">
                    <router-link :to="{ path: 'manage_float/' + float.id }">
                      <span class="text-indigo-600 hover:text-indigo-900">
                        View</span>
                    </router-link>
                  </td>
                </tr>

                <!-- More people... -->
              </tbody>
            </table>

            <!-- Empty State -->
            <div v-if="!loading && floats && floats.data && floats.data.length === 0" class="text-center py-12">
              <i class="bx bx-folder-open text-4xl text-gray-400"></i>
              <p class="mt-2 text-gray-500">No float records found</p>
              <p class="text-sm text-gray-400">Try adjusting your filters</p>
            </div>
          </div>

          <!-- Pagination -->
          <div v-if="floats && floats.meta && floats.meta.last_page > 1" class="mt-4 flex items-center justify-between">
            <div class="text-sm text-gray-600">
              Page {{ floats.meta.current_page }} of {{ floats.meta.last_page }}
            </div>
            <div class="flex items-center space-x-1">
              <!-- First Page -->
              <button 
                @click="goToPage(1)"
                :disabled="floats.meta.current_page === 1"
                class="px-3 py-1 border border-gray-300 rounded-md text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <i class="bx bx-chevrons-left"></i>
              </button>
              <!-- Previous Page -->
              <button 
                @click="goToPage(floats.meta.current_page - 1)"
                :disabled="floats.meta.current_page === 1"
                class="px-3 py-1 border border-gray-300 rounded-md text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <i class="bx bx-chevron-left"></i>
              </button>
              <!-- Page Numbers -->
              <button 
                v-for="page in visiblePages"
                :key="page"
                @click="goToPage(page)"
                  :class="[
                    'px-3 py-1 border rounded-md text-sm',
                    page === floats.meta.current_page 
                      ? 'bg-indigo-600 text-white border-indigo-600' 
                      : 'border-gray-300 hover:bg-gray-50'
                  ]"
                >
                  {{ page }}
              </button>
              <!-- Next Page -->
              <button 
                @click="goToPage(floats.meta.current_page + 1)"
                :disabled="floats.meta.current_page === floats.meta.last_page"
                class="px-3 py-1 border border-gray-300 rounded-md text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <i class="bx bx-chevron-right"></i>
              </button>
              <!-- Last Page -->
              <button 
                @click="goToPage(floats.meta.last_page)"
                :disabled="floats.meta.current_page === floats.meta.last_page"
                class="px-3 py-1 border border-gray-300 rounded-md text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <i class="bx bx-chevrons-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

        <!-- Results Info & Per Page -->
        <div class="flex items-center justify-between my-3">
            <div class="text-sm text-gray-600" v-if="floats && floats.meta">
                Showing {{ floats.meta.from || 0 }} to {{ floats.meta.to || 0 }} of {{ floats.meta.total || 0 }} results
            </div>
            <div class="flex items-center space-x-2">
                <label class="text-sm text-gray-600">Per page:</label>
                <select v-model="perPage" @change="applyFilters"
                    class="px-2 py-1 border border-gray-300 rounded-md text-sm focus:ring-indigo-500 focus:border-indigo-500">
                    <option :value="10">10</option>
                    <option :value="15">15</option>
                    <option :value="25">25</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                    <option :value="300">300</option>
                </select>
            </div>
        </div>
 
  </div>
</template>

<script>
import axios from "axios";
// import BranchSales from "../../components/Charts/BranchSales";

import { mapGetters } from "vuex";
import checkPermissionExist from "../../mixins/checkPermissionExist";

export default {
  middleware: "auth",
  layout: "default",
  components: {
    // BranchSales,
    // HelloWorld
  },

  mixins: [checkPermissionExist],
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
    visiblePages() {
      if (!this.floats || !this.floats.meta) return [];
      const current = this.floats.meta.current_page;
      const last = this.floats.meta.last_page;
      const delta = 2;
      const range = [];
      for (let i = Math.max(2, current - delta); i <= Math.min(last - 1, current + delta); i++) {
        range.push(i);
      }
      if (current - delta > 2) range.unshift('...');
      if (current + delta < last - 1) range.push('...');
      range.unshift(1);
      if (last > 1) range.push(last);
      return range.filter((item, index, arr) => {
        if (item === '...') return true;
        return arr.indexOf(item) === index;
      });
    },
    activeFilterCount() {
      let count = 0;
      if (this.filters.dateFrom) count++;
      if (this.filters.dateTo) count++;
      if (this.filters.createdFrom) count++;
      if (this.filters.createdTo) count++;
      if (this.filters.bank) count++;
      if (this.filters.createdBy) count++;
      return count;
    },
  },

  data: () => ({
    floats: null,
    loading: false,
    perPage: 15,
    showFilters: false,
    filters: {
      dateFrom: '',
      dateTo: '',
      createdFrom: '',
      createdTo: '',
      bank: '',
      createdBy: '',
    },
  }),

  created() {
    var _this = this;
    _this.loadData(1);
    if (!this.checkPermissionExist(this.user.data, "floats-read")) {
      this.$router.go(-1);
      return false;
    }
  },

  methods: {
    total(param) {
      return param.reduce(function (total, item) {
        return total + item.balance_allocated;
      }, 0);
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    applyFilters() {
      this.loadData(1);
    },

    clearFilters() {
      this.filters = {
        dateFrom: '',
        dateTo: '',
        createdFrom: '',
        createdTo: '',
        bank: '',
        createdBy: '',
      };
      this.loadData(1);
    },

    goToPage(page) {
      if (page === '...' || page < 1 || (this.floats && page > this.floats.meta.last_page)) return;
      this.loadData(page);
    },

    buildQueryParams(pageNo) {
      const params = new URLSearchParams();
      params.append('page', pageNo);
      params.append('per_page', this.perPage);
      
      if (this.filters.dateFrom) {
        params.append('date_from', this.filters.dateFrom);
      }
      if (this.filters.dateTo) {
        params.append('date_to', this.filters.dateTo);
      }
      if (this.filters.bank) {
        params.append('bank_name', this.filters.bank);
      }
      if (this.filters.createdBy) {
        params.append('created_by', this.filters.createdBy);
      }
      if (this.filters.createdFrom) {
        params.append('created_from', this.filters.createdFrom);
      }
      if (this.filters.createdTo) {
        params.append('created_to', this.filters.createdTo);
      }
      
      return params.toString();
    },

    async loadData(pageNo) {
      this.loading = true;

      try {
        const queryString = this.buildQueryParams(pageNo);
        const { data } = await axios.get(`/obtain_floats?${queryString}`);

        this.floats = data;
        this.loading = false;

        return true;
      } catch (e) {
        console.log("Error loading floats:", e);
        this.loading = false;
        return false;
      }
    },
  },
};
</script>
